<script setup lang="ts">
import {onMounted, ref} from "vue";
import CustomButton from "@/components/Button/Button.vue";
import CustomModal from "@/components/CustomModal/CustomModal.vue";
import TripCard from "@/components/TripCard/TripCard.vue";
import { useI18n } from 'vue-i18n'; // Import i18n
import { useTripsStore } from "@/stores/tripsStore";
import DateInput from "@/components/Global/DateInput.vue";

const { t } = useI18n(); // Initialize i18n

const showAddTripModal = ref(false);
const tripsStore = useTripsStore();
const tripName = ref('');


const updateTrips = async () => {
  try {
    tripsStore.getAll();
  } catch(err) {
    console.log('Request failed: ', err.message);
  }
}


onMounted(() => {

  tripsStore.getAll();
  setInterval(updateTrips, 5000);

})

function onBook() {
  showAddTripModal.value = false;
  tripsStore.create(
{
        name: tripName.value,
        dateStart: new Date(),
        dateTo: new Date()
      }
  );
}

function onDelete(id: string) {
  tripsStore.remove(id)
}

function onEdit(data: { id: string, name: string }) {
  tripsStore.update(data.id, data);
}

//TODO Handle Loading
</script>

<template>
  <div class="container flex flex-col mt-5">
    <div class="flex flex-row justify-between items-end">
      <div class="trips__title responsive-title-5 font-semibold">
        {{ t('myTrips') }}
      </div>
      <CustomButton v-if="tripsStore.hasTrips()" type="black" :rounded="true" class="trips-add__button h-8"
                    @click="showAddTripModal = true">
        {{ t('createNewTrip') }}
      </CustomButton>
    </div>
    <div :class="`trips-grid mt-5 ${!tripsStore.hasTrips() ? 'content-center min-h-[68.5vh]' : ''}`">
      <div v-if="!tripsStore.hasTrips()" class="flex justify-center items-center lg:gap-6 gap-4">
        <div class="flex flex-col bg-background-light box-class justify-between rounded-12xl p-5">
          <div>
            <img src="@/assets/icons/svg/Luggage_40x40.svg" alt="Suitcase">
          </div>
          <div class="text-12xl font-semibold">{{ t('noTrips') }}</div>
        </div>
        <div @click="showAddTripModal = true"
             class="flex flex-col bg-primary-blue text-white justify-center items-center rounded-12xl p-5 gap-4 cursor-pointer box-class"
             type="primary">
          <img src="@/assets/icons/svg/Add_24x24_white.svg" alt="Plus" width="48"/>
          <div class="text-12xl font-semibold">{{ t('addNewTrip') }}</div>
        </div>
      </div>
      <div v-else-if="tripsStore.hasTrips()"
           class="trip-grid-content grid 2xl:grid-cols-5 lg:grid-cols-4 grid-cols-3  gap-6">
        <TripCard v-for="trip in tripsStore.trips" :trip="trip" :key="trip.uuid"
                  @on-delete-click="onDelete"
                  @on-edit-click="onEdit"/>
      </div>
    </div>
  </div>
  <CustomModal :show="showAddTripModal" classes="w-1/6" @close="showAddTripModal = false" :mobile-fullscreen="false">
    <div class="flex flex-col p-6">
      <div class="cursor-pointer self-end close-div" type="default" @click="showAddTripModal = false">
        <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18"/>
      </div>
      <div class="flex flex-col gap-8 p-8">
        <div class="responsive-title-6 font-semibold">{{ t('createNewTrip') }}</div>
        <input v-model="tripName" type="text" :placeholder="t('addTripName')" class="border-b"/>
        <CustomButton type="black" class="self-start" :rounded="true" @click="onBook">{{ t('create') }}</CustomButton>
      </div>

    </div>
  </CustomModal>
</template>

<style scoped>
:deep(.modal-content) {
  @apply w-1/4;
}

.box-class {
  min-width: 10vw;
  height: 15.5rem;
}

@media (max-width: 1600px) {
  .box-class {
    min-width: 14vw;
  }
}
@media (max-width: 1350px) {
  .box-class {
    min-width: 19vw;
  }
}

@media (max-width: 1024px) {
  .trips-add__button {
    font-size: .875rem;
  }
  .box-class {
    min-width: 30vw;
  }
}

@media (max-width: 786px) and (min-width: 541px) {
  .trip-grid-content {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 540px) {
  .trips-grid {
    align-content: start;
    min-height: 20rem;
  }
  .box-class {
    min-width: 42vw;
    height: 11.4375rem;
  }
  .box-class img[alt="Plus"] {
    height: 2.75rem;
    width: 2.75rem;
  }
  .box-class img[alt="Suitcase"] {
    height: 1.875rem;
    width: 1.875rem;
  }
  .trip-grid-content {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

@media (max-width: 400px) {
  .trips-add__button {
    font-size: .75rem;
  }
}

</style>
